/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PricingModeInputDto } from './PricingModeInputDto';
export type PricingItemDto = {
    /**
     * Service type UUID
     */
    service_type_id: string;
    /**
     * Session type
     */
    session_type: PricingItemDto.session_type;
    /**
     * Mode-wise pricing. Send only modes with a filled single_session_price. Omitted modes are removed on save.
     */
    modes: Array<PricingModeInputDto>;
};
export namespace PricingItemDto {
    /**
     * Session type
     */
    export enum session_type {
        SINGLE = 'single',
        DUO = 'duo',
    }
}

